<app-action-item borderColor="var(--shade-2-color)" titleColor="#000000" backgroundColor="var(--shade-2-color)"
  color="#000000" titleDictionaryKey="dd.appc_cfg_action_item.{{actionItem.id}}.name"
  *ngFor="let transport of transports" iconCSS="fa-xmark">
  <sc-flex vertical stretchContent fitHeight>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
          [transport]="transport">
        </app-transport-details>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
    <div>
      <sc-flex centered>
        <sc-action-icon iconClass="fa-check fa-2x" (click)="handleLeave(transport)"></sc-action-icon>
        <sc-content-spacer></sc-content-spacer>
        <sc-action-icon iconClass="fa-xmark fa-2x" (click)="handleCancel(transport)"></sc-action-icon>
      </sc-flex>
    </div>
  </sc-flex>
</app-action-item>
